
import Vue from 'vue'
import VueScrollTo from 'vue-scrollto'
import {Component} from 'vue-property-decorator'
import {Action, Getter, namespace} from 'vuex-class'
import BaseCardContainer from '@/containers/base/BaseCardContainer.vue'
import EssaiForm from '@/components/forms/EssaiForm.vue'

const prospectModule = namespace('prospect')
const essaiModule = namespace('essai')

@Component({
  components: {
    BaseCardContainer,
    EssaiForm
  }
})
export default class ProspectEssaiCreate extends Vue {
  @prospectModule.Getter('prospectGetter') prospect: any
  @prospectModule.Action('getProspectByIdAction') getProspectById: any
  @essaiModule.Action('createEssaiAction') createEssai: any

  get relation() {
    return {
      to: 'prospect',
      key: 'ID_PROSPECT',
      value: this.$route.params.id
    }
  }

  get hasEmailContacts() {
    const data = this.prospect ? this.prospect.CONTACTS : null
    if (!data) {
      return true
    } else {
      const arr = data.find((item) => item.EMAIL !== null)
      if (!arr) return false
      else return true
    }
  }

  mounted() {
    this.$nextTick(() => VueScrollTo.scrollTo('#form'))
  }

  onSubmit(data: any) {
    this.createEssai(data).then(async (data: any) => {
      await this.getProspectById(this.$route.params.id)
      this.$router.push({name: 'prospectEssai', params: {id: this.$route.params.id}})
    })
  }

  onCancel() {
    this.$router.replace({name: 'prospectEssai', params: {id: this.$route.params.id}})
  }
}
